import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { toKnownSection } from '../core/helpers/section-route';
import { User, UserService } from '../core/user/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountSection, AccountService } from './account.service';
import { objectPropertiesToArray } from '@rallycommerce/common/utils.js';
import { SessionService } from '../core/session.service';
import { AnalyticsPage } from '../core/internal-analytics.service';
import { PageService } from '../core/page.service';
@Component({
  selector: 'rosie-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  standalone: false
})
export class AccountComponent implements OnInit {
  AccountSection = AccountSection;
  private hoverState: { [key: string]: boolean } = {};

  constructor(private user: UserService, private translate: TranslateService, private router: Router, private account: AccountService, private route: ActivatedRoute, private session: SessionService, private page: PageService) {
    this.page.initializePage(`Rosie - Account Settings`, AnalyticsPage.Account);
  }

  get userData(): User {
    return this.user.userData;
  }

  get isMobileVersion(): boolean {
    return this.account.isMobileVersion
  }

  get activeSection(): AccountSection {
    return this.account.activeSection;
  }

  get sections(): string[] {
    return objectPropertiesToArray(AccountSection);
  }

  get hasHideMenuParam(): boolean {
    return new URLSearchParams(window.location.search).get('menu') === 'false';
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((paramMap) => {
      const selectedSection = toKnownSection(paramMap.get('section'), AccountSection);
      if (this.account.activeSection !== selectedSection && (!this.isMobileVersion || (this.isMobileVersion && selectedSection))) {
        this.account.activeSection = selectedSection || AccountSection.Profile;
      }
    });
    this.session.refreshState.subscribe(() => this.user.getUser());
  }

  isHovered(key: AccountSection): boolean {
    return !!this.hoverState?.[key];
  }


  onMouseEnter(key: AccountSection): void {
    this.hoverState[key] = true;
  }

  onMouseLeave(key: AccountSection): void {
    this.hoverState[key] = false;
  }


  handleSettingsSectionChange(section: AccountSection): void {
    this.router.navigate(['/account', { section }]);
  }

  getTranslation(section: string, translationKey: string): string {
    return this.translate.instant(`ACCOUNT.${section?.toUpperCase()}.${translationKey?.toUpperCase()}`);
  }

  getIcon(section: string): string {
    return sectionIcons[section];
  }

  back() {
    this.account.activeSection = null;
    this.router.navigate(['/account']);
  }
}

export const sectionIcons = {
  [AccountSection.Profile]: 'heroClipboard',
  [AccountSection.Billing]: 'heroCreditCard',
  [AccountSection.Notifications]: 'heroBell',
  [AccountSection.Users]: 'heroUsers',
};